import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import { useState } from 'react';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import clearSVG from '@plone/volto/icons/clear.svg';
import leftKey from '@plone/volto/icons/left-key.svg';
import rightKey from '@plone/volto/icons/right-key.svg';

const messages = defineMessages({
  startDate: {
    id: 'Start Date',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: 'End Date',
    defaultMessage: 'End Date',
  },
  clearDates: {
    id: 'Clear dates',
    defaultMessage: 'Clear dates',
  },
  previousMonth: {
    id: 'Previous month',
    defaultMessage: 'Previous month',
  },
  nextMonth: {
    id: 'Next month',
    defaultMessage: 'Next month',
  },
});

const PrevIcon = () => (
  <div
    className="prev-icon"
    aria-hidden="true"
    style={{
      color: '#000',
      left: '22px',
      padding: '5px',
      position: 'absolute',
      top: '15px',
    }}
  >
    <Icon name={leftKey} size="30px" />
  </div>
);

const NextIcon = () => (
  <div
    className="next-icon"
    aria-hidden="true"
    style={{
      color: '#000',
      right: '22px',
      padding: '5px',
      position: 'absolute',
      top: '15px',
    }}
  >
    <Icon name={rightKey} size="30px" />
  </div>
);

const CloseIcon = () => (
  <Icon name={clearSVG} size="24px" className="close" aria-hidden="true" />
);

const DateRangeFacet = (props) => {
  const { facet, isEditMode, onChange, value, reactDates, intl, lang } = props;
  const moment = props.moment.default;
  const { DateRangePicker } = reactDates;
  const [focused, setFocused] = useState(null);

  const startDateLabel = intl.formatMessage(messages.startDate);
  const endDateLabel = intl.formatMessage(messages.endDate);

  return (
    <div className="daterange-facet">
      <div className="text-semi-bold text-up-01 border-bottom mb-3 pb-1">
        {facet?.title ?? facet?.field?.label}
      </div>
      <div className="ui form date-time-widget-wrapper">
        <div className="ui input date-input">
          <DateRangePicker
            startDate={value && value[0] ? moment(value[0]) : null}
            endDate={value && value[1] ? moment(value[1]) : null}
            startDateId={`${facet['@id']}-start-date`}
            endDateId={`${facet['@id']}-end-date`}
            startDatePlaceholderText={startDateLabel}
            endDatePlaceholderText={endDateLabel}
            startDateAriaLabel={startDateLabel}
            endDateAriaLabel={endDateLabel}
            numberOfMonths={1}
            disabled={isEditMode}
            noBorder
            showClearDates
            customCloseIcon={<CloseIcon />}
            displayFormat={moment
              .localeData(toBackendLang(lang))
              .longDateFormat('L')}
            focusedInput={focused}
            onFocusChange={(focusedInput) => setFocused(focusedInput)}
            onDatesChange={({ startDate, endDate }) => {
              onChange(facet.field.value, [
                startDate
                  ? startDate.startOf('day').format('YYYY-MM-DD HH:mm:ss')
                  : null,
                endDate
                  ? endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')
                  : null,
              ]);
            }}
            isOutsideRange={() => false}
            minimumNights={0}
            navPrev={<PrevIcon />}
            navNext={<NextIcon />}
            phrases={{
              clearDates: intl.formatMessage(messages.clearDates),
              jumpToPrevMonth: intl.formatMessage(messages.previousMonth),
              jumpToNextMonth: intl.formatMessage(messages.nextMonth),
            }}
          />
        </div>
      </div>
    </div>
  );
};

DateRangeFacet.stateToValue = ({ facetSettings, index, selectedValue }) => {
  return selectedValue || [null, null];
};

DateRangeFacet.valueToQuery = ({ value, facet }) => {
  return value && (typeof value[0] === 'string' || typeof value[1] === 'string')
    ? {
        i: facet.field.value,
        o: 'plone.app.querystring.operation.date.between',
        v: value,
      }
    : null;
};

export default compose(
  injectLazyLibs(['reactDates', 'moment']),
  connect((state) => ({
    lang: state.intl.locale,
  })),
  injectIntl,
)(DateRangeFacet);
